(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ZN_SECTION_ID = '{{ zn_id }}';

    function znEscapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    /* ---------------- Drawer open/close ---------------- */
    function znOpenDrawer(id, openBtn) {
      var drawer = document.querySelector('[data-zn-drawer="' + id + '"]');
      if (!drawer) return;
     setTimeout(function () {
  if (!drawer.classList.contains('zn-is-open')) {
    drawer.style.display = 'none';
  }
}, 300);
      void drawer.offsetWidth;
      drawer.classList.add('zn-is-open');
      document.body.classList.add('zn-drawer-open-' + id);
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    }

    function znCloseDrawer(id) {
      var drawer = document.querySelector('[data-zn-drawer="' + id + '"]');
      if (!drawer) return;
      drawer.classList.remove('zn-is-open');
      document.body.classList.remove('zn-drawer-open-' + id);
      setTimeout(function () {
        if (!drawer.classList.contains('zn-is-open')) {
          drawer.style.display = 'none';
        }
      }, 300);
    }

    /* ---------------- Predictive search ---------------- */
    var znSearchTimers = {};

    function znRenderResults(container, products, query, searchUrl) {
      if (!products || products.length === 0) {
        container.innerHTML = '<div class="zn-result-empty">No products found for "' + znEscapeHtml(query) + '"</div>';
        container.classList.add('zn-is-open');
        return;
      }
      var html = '';
      products.forEach(function (product) {
        var img = product.image || (product.featured_image && product.featured_image.url) || '';
        if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=100';
        html +=
          '<a class="zn-result-item" href="' + product.url + '">' +
            '<span class="zn-result-img">' +
              (img ? '<img src="' + img + '" alt="' + znEscapeHtml(product.title) + '" loading="lazy">' : '') +
            '</span>' +
            '<span class="zn-result-info">' +
              '<span class="zn-result-title">' + znEscapeHtml(product.title) + '</span>' +
              (product.price ? '<span class="zn-result-price">' + product.price + '</span>' : '') +
            '</span>' +
          '</a>';
      });
      html +=
        '<a class="zn-result-viewall" href="' + searchUrl + '?q=' + encodeURIComponent(query) + '&type=product">View all results</a>';
      container.innerHTML = html;
      container.classList.add('zn-is-open');
    }

    function znFetchPredictiveSearch(input, container) {
      var query = input.value.trim();
      if (!query) {
        container.classList.remove('zn-is-open');
        container.innerHTML = '';
        return;
      }
      container.innerHTML = '<div class="zn-result-loading">Searching…</div>';
      container.classList.add('zn-is-open');

      fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = data && data.resources && data.resources.results && data.resources.results.products
            ? data.resources.results.products : [];
          var searchForm = input.closest('form');
          var searchUrl = searchForm ? searchForm.getAttribute('action') : '/search';
          znRenderResults(container, products, query, searchUrl);
        })
        .catch(function () {
          container.innerHTML = '';
          container.classList.remove('zn-is-open');
        });
    }

    function znWireSearch(root) {
      root.querySelectorAll('[data-zn-search-input]').forEach(function (input) {
        if (input.dataset.znWired === '1') return; // avoid double-binding
        input.dataset.znWired = '1';

        var key = input.getAttribute('data-zn-search-input');
        var results = document.querySelector('[data-zn-search-results="' + key + '"]');
        if (!results) return;

        input.addEventListener('input', function () {
          clearTimeout(znSearchTimers[key]);
          znSearchTimers[key] = setTimeout(function () {
            znFetchPredictiveSearch(input, results);
          }, 300);
        });

        input.addEventListener('focus', function () {
          if (input.value.trim() && results.innerHTML) {
            results.classList.add('zn-is-open');
          }
        });
      });
    }

    /* ---------------- Core init: move drawer to <body> safely ---------------- */
    function znInitSection(sectionId) {
      // 1. Remove any stray/duplicate drawer already sitting in <body> for this
      //    section id (left behind by a previous Theme Editor re-render).
      document.querySelectorAll('body > [data-zn-drawer="' + sectionId + '"]').forEach(function (old) {
        old.remove();
      });

      // 2. Find the freshly-rendered drawer that lives inside the section markup
      //    (not the one already relocated to body) and move THAT one.
      var freshDrawer = document.querySelector(
        '[data-zn-drawer="' + sectionId + '"]:not([data-zn-relocated])'
      );
      if (freshDrawer) {
        freshDrawer.setAttribute('data-zn-relocated', '1');
        document.body.appendChild(freshDrawer);
      }

      znWireSearch(document);
    }

    /* Run on normal page load */
    document.addEventListener('DOMContentLoaded', function () {
      znInitSection(ZN_SECTION_ID);
    });
    // In case DOMContentLoaded already fired before this script executed
    if (document.readyState === 'interactive' || document.readyState === 'complete') {
      znInitSection(ZN_SECTION_ID);
    }

    /* Re-init only THIS section when the Theme Editor swaps its HTML back in.
       This is what stops the duplicate/leaked drawer content bug. */
    document.addEventListener('shopify:section:load', function (evt) {
      if (evt.target.querySelector('[data-zn-drawer="' + ZN_SECTION_ID + '"]')) {
        znInitSection(ZN_SECTION_ID);
      }
    });

    /* Clean up the relocated drawer node when the section is removed/reloaded
       in the editor, so nothing orphaned is left in <body>. */
    document.addEventListener('shopify:section:unload', function (evt) {
      if (evt.detail && evt.detail.sectionId === ZN_SECTION_ID) {
        document.querySelectorAll('body > [data-zn-drawer="' + ZN_SECTION_ID + '"]').forEach(function (old) {
          old.remove();
        });
      }
    });

    /* ---------------- Global click/keyboard handlers (bind once, ever) ---------------- */
    if (!window.__znHeaderGlobalBound) {
      window.__znHeaderGlobalBound = true;

      document.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-zn-open]');
        var closeTarget = e.target.closest('[data-zn-close]');
        var accordionBtn = e.target.closest('[data-zn-accordion]');

        if (openBtn) znOpenDrawer(openBtn.getAttribute('data-zn-open'), openBtn);
        if (closeTarget) znCloseDrawer(closeTarget.getAttribute('data-zn-close'));

        if (accordionBtn) {
          var submenu = accordionBtn.nextElementSibling;
          var isOpen = accordionBtn.getAttribute('aria-expanded') === 'true';
          accordionBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (submenu) submenu.classList.toggle('zn-is-open', !isOpen);
        }

        document.querySelectorAll('.zn-search-results.zn-is-open').forEach(function (r) {
          var wrapper = r.closest('.zn-search') || r.closest('.zn-drawer__search-wrap');
          if (wrapper && !wrapper.contains(e.target)) {
            r.classList.remove('zn-is-open');
          }
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('[data-zn-drawer].zn-is-open').forEach(function (d) {
            znCloseDrawer(d.getAttribute('data-zn-drawer'));
          });
          document.querySelectorAll('.zn-search-results.zn-is-open').forEach(function (r) {
            r.classList.remove('zn-is-open');
          });
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-zn-open]');
      var closeTarget = e.target.closest('[data-zn-close]');
      var accordionBtn = e.target.closest('[data-zn-accordion]');

      if (openBtn) {
        var id = openBtn.getAttribute('data-zn-open');
        var drawer = document.querySelector('[data-zn-drawer="' + id + '"]');
        if (drawer) {
          drawer.classList.add('zn-is-open');
          document.body.classList.add('zn-drawer-open-' + id);
          openBtn.setAttribute('aria-expanded', 'true');
        }
      }

      if (closeTarget) {
        var cid = closeTarget.getAttribute('data-zn-close');
        var d = document.querySelector('[data-zn-drawer="' + cid + '"]');
        if (d) {
          d.classList.remove('zn-is-open');
          document.body.classList.remove('zn-drawer-open-' + cid);
        }
      }

      if (accordionBtn) {
        var submenu = accordionBtn.nextElementSibling;
        var isOpen = accordionBtn.getAttribute('aria-expanded') === 'true';
        accordionBtn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (submenu) {
          submenu.classList.toggle('zn-is-open', !isOpen);
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-zn-drawer].zn-is-open').forEach(function (d) {
          d.classList.remove('zn-is-open');
        });
        document.querySelectorAll('.zn-search-results.zn-is-open').forEach(function (r) {
          r.classList.remove('zn-is-open');
        });
      }
    });

    /* ---------------- Live predictive search ---------------- */
    var znSearchTimers = {};

    function znEscapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    function znRenderResults(container, products, query, searchUrl) {
      if (!products || products.length === 0) {
        container.innerHTML = '<div class="zn-result-empty">No products found for "' + znEscapeHtml(query) + '"</div>';
        container.classList.add('zn-is-open');
        return;
      }

      var html = '';
      products.forEach(function (product) {
        var img =
          product.image ||
          (product.featured_image && product.featured_image.url) ||
          '';

        if (img) {
          img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=100';
        }
        html +=
          '<a class="zn-result-item" href="' + product.url + '">' +
            '<span class="zn-result-img">' +
              (img ? '<img src="' + img + '" alt="' + znEscapeHtml(product.title) + '" loading="lazy">' : '') +
            '</span>' +
            '<span class="zn-result-info">' +
              '<span class="zn-result-title">' + znEscapeHtml(product.title) + '</span>' +
              (product.price ? '<span class="zn-result-price">' + product.price + '</span>' : '') +
            '</span>' +
          '</a>';
      });

      html +=
        '<a class="zn-result-viewall" href="' + searchUrl + '?q=' + encodeURIComponent(query) + '&type=product">' +
          'View all results' +
        '</a>';

      container.innerHTML = html;
      container.classList.add('zn-is-open');
    }

    function znFetchPredictiveSearch(input, container) {
      var query = input.value.trim();

      if (!query) {
        container.classList.remove('zn-is-open');
        container.innerHTML = '';
        return;
      }

      container.innerHTML = '<div class="zn-result-loading">Searching…</div>';
      container.classList.add('zn-is-open');

      fetch(
        '/search/suggest.json?q=' +
          encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last'
      )
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          var products =
            data && data.resources && data.resources.results && data.resources.results.products
              ? data.resources.results.products
              : [];
          var searchForm = input.closest('form');
          var searchUrl = searchForm ? searchForm.getAttribute('action') : '/search';
          znRenderResults(container, products, query, searchUrl);
        })
        .catch(function () {
          container.innerHTML = '';
          container.classList.remove('zn-is-open');
        });
    }

    document.querySelectorAll('[data-zn-search-input]').forEach(function (input) {
      var key = input.getAttribute('data-zn-search-input');
      var results = document.querySelector('[data-zn-search-results="' + key + '"]');
      if (!results) return;

      input.addEventListener('input', function () {
        clearTimeout(znSearchTimers[key]);
        znSearchTimers[key] = setTimeout(function () {
          znFetchPredictiveSearch(input, results);
        }, 300);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim() && results.innerHTML) {
          results.classList.add('zn-is-open');
        }
      });
    });

    document.addEventListener('click', function (e) {
      document.querySelectorAll('.zn-search-results.zn-is-open').forEach(function (r) {
        var wrapper = r.closest('.zn-search') || r.closest('.zn-drawer__search-wrap');
        if (wrapper && !wrapper.contains(e.target)) {
          r.classList.remove('zn-is-open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
